import { Button, Col, Form, FormInstance, Input, InputNumber, Modal, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import FormLabel from "src/components/AntdCustomPart/FormLabel/FormLabel";
import ModalTitle from "src/components/AntdCustomPart/ModalTitle/ModalTitle";
import { SettingSTDControlFugitive } from "src/entity/settings/fugitive";
import { generateErrorMessage } from "src/utils/error-message";
import { onKeyDownNumberWithFixedDecimal } from "src/utils/key-down-validate";
import { formatNumber } from "src/utils/process-number";

const { Text } = Typography;

const FugitiveSTDControlModal = (props: {
  form: FormInstance;
  open: boolean;
  loading: boolean;
  mode: "insert" | "update";
  isDuplicate: boolean;
  onDuplicateChange: (isDup: boolean) => void;
  onCloseModal: () => void;
  onSave: (mode: "insert" | "update", data: SettingSTDControlFugitive) => void;
}) => {
  const { form, loading, open, mode, isDuplicate, onDuplicateChange, onCloseModal, onSave } = props;
  const [errorDuplicate, setErrorDuplicate] = useState<string | null>(null);

  const handleSave = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue();
      onSave(mode, values);
    } catch (error) {
      console.error(error);
    }
  };

  const onChangeForm = (changeValue: any) => {
    if (["emission", "std"].some((key) => changeValue[key])) {
      onDuplicateChange(false);
    }
  };

  useEffect(() => {
    const errorText = isDuplicate ? "Emission already exists in the system." : "";
    setErrorDuplicate(errorText);
    form.setFields(
      ["emission"].map((field) => ({
        name: field,
        errors: isDuplicate ? [""] : [],
      })),
    );
  }, [isDuplicate]);

  return (
    <div>
      <Modal
        centered
        maskClosable={false}
        open={open}
        onCancel={onCloseModal}
        width={700}
        title={<ModalTitle title="STD Control" />}
        footer={
          <Row className="w-full border-t" justify={"end"}>
            <Button className="mt-4" key="submit" type="primary" loading={loading} onClick={handleSave}>
              Save
            </Button>
          </Row>
        }
      >
        {errorDuplicate && (
          <>
            <Row className="w-full" justify={"center"}>
              <Text type="danger">{errorDuplicate}</Text>
            </Row>
          </>
        )}
        <Form size="middle" layout="vertical" autoComplete="off" form={form} requiredMark={false} onValuesChange={onChangeForm}>
          <Row gutter={[16, 0]}>
            <Col xs={24}>
              <Form.Item
                label={<FormLabel label={"Emission"} required />}
                name="emission"
                rules={[
                  {
                    required: true,
                    message: generateErrorMessage("Emission"),
                  },
                ]}
              >
                <Input />
              </Form.Item>
            </Col>

            <Col xs={24}>
              <Form.Item
                label={<FormLabel label={"STD (ppm as TVOCs)"} required />}
                name="std"
                rules={[
                  {
                    required: true,
                    message: generateErrorMessage("STD (ppm as TVOCs)"),
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  onKeyDown={(e) => {
                    onKeyDownNumberWithFixedDecimal(e, 0);
                  }}
                  formatter={(value) => formatNumber(value as number, 0)}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default FugitiveSTDControlModal;
